export default [
	{
		path: '/courseBoard',
		component: () => import('../../sys/analysis/board/courseBoard.vue')
	},
	//校级数据大屏
	{
		path: '/schoolBoard',
		component: () => import('../../sys/analysis/board/schoolBoard.vue')
	}
]
